import React, { useState } from 'react';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import * as XLSX from 'xlsx';
import Navbar from '../../components/navbar/navbar.jsx';
import apinode from '../../services/apinode.js';

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

// ─────────────────────────────────────────────
// MODAL DE PEDIDOS POR SKU
// ─────────────────────────────────────────────
const PedidosModal = ({ show, onClose, produto, pedidos, formatCurrency }) => {
  if (!show || !produto) return null;

  // Filtra os pedidos deste SKU + loja (se loja informada)
  const pedidosFiltrados = pedidos.filter(p =>
    p.sku === produto.sku &&
    (produto.id_loja ? p.id_loja === produto.id_loja : true)
  );

  const total = pedidosFiltrados.reduce((acc, p) => ({
    quantidade: acc.quantidade + (p.quantidade_nova || 0),
    venda:      acc.venda      + (p.valor_total_item  || 0),
    custo:      acc.custo      + (p.custo_item         || 0),
    lucro:      acc.lucro      + (p.lucro_item         || 0),
  }), { quantidade: 0, venda: 0, custo: 0, lucro: 0 });

  const margemTotal = total.venda > 0
    ? ((total.lucro / total.venda) * 100).toFixed(1) : 0;

  return (
    <>
      {/* Overlay — z maior que o MarcasModal */}
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', zIndex: 1060 }}
      />

      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '94vw', maxWidth: 980, maxHeight: '88vh',
        background: '#fff', borderRadius: 14, zIndex: 1061,
        display: 'flex', flexDirection: 'column',
        boxShadow: '0 24px 64px rgba(0,0,0,0.35)', overflow: 'hidden',
      }}>

        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #198754 0%, #146c43 100%)',
          padding: '16px 22px', display: 'flex',
          alignItems: 'center', justifyContent: 'space-between', flexShrink: 0,
        }}>
          <div>
            <h5 style={{ color: '#fff', margin: 0, fontWeight: 700 }}>
              🧾 Pedidos — {produto.sku}
            </h5>
            <small style={{ color: 'rgba(255,255,255,0.8)' }}>
              {produto.descricao?.substring(0, 60)}
              {produto.id_loja ? ` · ${produto.id_loja}` : ' · Todas as lojas'}
            </small>
          </div>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.2)', border: 'none',
            borderRadius: 8, color: '#fff', fontWeight: 700,
            fontSize: 18, width: 36, height: 36, cursor: 'pointer', lineHeight: 1,
          }}>×</button>
        </div>

        {/* Cards resumo */}
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)',
          gap: 10, padding: '12px 22px',
          borderBottom: '1px solid #e9ecef', flexShrink: 0,
        }}>
          {[
            { label: 'Pedidos',      value: pedidosFiltrados.length,         bg: '#6c757d', icon: '📋' },
            { label: 'Qtd Vendida',  value: total.quantidade,                bg: '#0d6efd', icon: '📦' },
            { label: 'Faturamento',  value: formatCurrency(total.venda),     bg: '#198754', icon: '💰' },
            { label: 'Custo Total',  value: formatCurrency(total.custo),     bg: '#dc3545', icon: '🏷️' },
            { label: 'Lucro / Mg',   value: `${formatCurrency(total.lucro)} · ${margemTotal}%`, bg: '#fd7e14', icon: '💵' },
          ].map((c, i) => (
            <div key={i} style={{ background: c.bg, borderRadius: 9, padding: '9px 12px', color: '#fff' }}>
              <div style={{ fontSize: 10, opacity: 0.8, fontWeight: 600 }}>{c.icon} {c.label}</div>
              <div style={{ fontSize: 13, fontWeight: 700, marginTop: 3 }}>{c.value}</div>
            </div>
          ))}
        </div>

        {/* Tabela de pedidos */}
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {pedidosFiltrados.length === 0 ? (
            <div style={{ padding: 32, textAlign: 'center', color: '#6c757d' }}>
              Nenhum pedido encontrado para este SKU.
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead style={{ position: 'sticky', top: 0 }}>
                <tr style={{ background: '#e9f5ee' }}>
                  {[
                    { label: 'Pedido',      align: 'left'  },
                    { label: 'Data',        align: 'left'  },
                    { label: 'Loja',        align: 'left'  },
                    { label: 'Qtd',         align: 'right' },
                    { label: 'Vl. Unit.',   align: 'right' },
                    { label: 'Desconto',    align: 'right' },
                    { label: 'Total Item',  align: 'right' },
                    { label: 'Custo',       align: 'right' },
                    { label: 'Lucro',       align: 'right' },
                    { label: 'Margem',      align: 'right' },
                  ].map(h => (
                    <th key={h.label} style={{
                      padding: '8px 10px', fontWeight: 600, color: '#198754',
                      textAlign: h.align, borderBottom: '2px solid #c3e6cb',
                      whiteSpace: 'nowrap',
                    }}>{h.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pedidosFiltrados.map((ped, idx) => {
                  const margem = ped.valor_total_item > 0
                    ? ((ped.lucro_item / ped.valor_total_item) * 100).toFixed(1) : 0;
                  const mColor = parseFloat(margem) >= 30 ? '#198754'
                    : parseFloat(margem) >= 10 ? '#fd7e14' : '#dc3545';
                  return (
                    <tr key={idx} style={{ background: idx % 2 === 0 ? '#f8f9fa' : '#fff' }}>
                      <td style={{ padding: '6px 10px', fontWeight: 600, color: '#0d6efd', whiteSpace: 'nowrap' }}>
                        #{ped.pedido}
                      </td>
                      <td style={{ padding: '6px 10px', whiteSpace: 'nowrap', color: '#495057' }}>
                        {ped.data_pedido
                          ? new Date(ped.data_pedido).toLocaleDateString('pt-BR')
                          : '—'}
                      </td>
                      <td style={{ padding: '6px 10px', whiteSpace: 'nowrap' }}>{ped.id_loja}</td>
                      <td style={{ padding: '6px 10px', textAlign: 'right', fontWeight: 600 }}>
                        {ped.quantidade_nova}
                      </td>
                      <td style={{ padding: '6px 10px', textAlign: 'right' }}>
                        {formatCurrency(ped.valorunitario)}
                      </td>
                      <td style={{ padding: '6px 10px', textAlign: 'right', color: '#dc3545' }}>
                        {ped.desconto > 0 ? `-${formatCurrency(ped.desconto)}` : '—'}
                      </td>
                      <td style={{ padding: '6px 10px', textAlign: 'right', color: '#198754', fontWeight: 700 }}>
                        {formatCurrency(ped.valor_total_item)}
                      </td>
                      <td style={{ padding: '6px 10px', textAlign: 'right', color: '#dc3545' }}>
                        {formatCurrency(ped.custo_item)}
                      </td>
                      <td style={{ padding: '6px 10px', textAlign: 'right', color: '#0d6efd', fontWeight: 700 }}>
                        {formatCurrency(ped.lucro_item)}
                      </td>
                      <td style={{ padding: '6px 10px', textAlign: 'right', fontWeight: 700, color: mColor }}>
                        {margem}%
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ background: '#c3e6cb', fontWeight: 700 }}>
                  <td colSpan={3} style={{ padding: '8px 10px', color: '#198754' }}>
                    Subtotal ({pedidosFiltrados.length} pedidos)
                  </td>
                  <td style={{ padding: '8px 10px', textAlign: 'right' }}>{total.quantidade}</td>
                  <td colSpan={2} />
                  <td style={{ padding: '8px 10px', textAlign: 'right', color: '#198754' }}>
                    {formatCurrency(total.venda)}
                  </td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', color: '#dc3545' }}>
                    {formatCurrency(total.custo)}
                  </td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', color: '#0d6efd' }}>
                    {formatCurrency(total.lucro)}
                  </td>
                  <td style={{ padding: '8px 10px', textAlign: 'right', color: '#198754' }}>
                    {margemTotal}%
                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </div>
    </>
  );
};

// ─────────────────────────────────────────────
// MODAL DE MARCAS
// ─────────────────────────────────────────────
const MarcasModal = ({ show, onClose, data, pedidos, formatCurrency }) => {
  const [sortMarca, setSortMarca]                 = useState('faturamento');
  const [selectedLojaMarca, setSelectedLojaMarca] = useState('all');
  const [expandida, setExpandida]                 = useState(null);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);

  if (!show) return null;

  const lojas = [...new Set(data.map(d => d.id_loja))].sort();

  const dadosFiltrados = selectedLojaMarca === 'all'
    ? data
    : data.filter(d => d.id_loja === selectedLojaMarca);

  const marcaMap = {};
  dadosFiltrados.forEach(item => {
    const chave = item.desc_marca || 'SEM MARCA';
    if (!marcaMap[chave]) {
      marcaMap[chave] = {
        desc_marca: chave,
        total_venda: 0, total_custo: 0,
        lucro_total: 0, total_quantidade: 0,
        skus: new Set(), produtos: [],
      };
    }
    marcaMap[chave].total_venda      += item.total_venda;
    marcaMap[chave].total_custo      += item.total_custo;
    marcaMap[chave].lucro_total      += item.lucro_total;
    marcaMap[chave].total_quantidade += item.total_quantidade;
    marcaMap[chave].skus.add(item.sku);
    marcaMap[chave].produtos.push(item);
  });

  let marcas = Object.values(marcaMap).map(m => ({
    ...m,
    skus: m.skus.size,
    margem: m.total_venda > 0 ? ((m.lucro_total / m.total_venda) * 100) : 0,
    produtos: m.produtos.sort((a, b) => b.total_venda - a.total_venda),
  }));

  switch (sortMarca) {
    case 'faturamento': marcas.sort((a, b) => b.total_venda      - a.total_venda);      break;
    case 'lucro':       marcas.sort((a, b) => b.lucro_total      - a.lucro_total);      break;
    case 'quantidade':  marcas.sort((a, b) => b.total_quantidade - a.total_quantidade); break;
    case 'margem':      marcas.sort((a, b) => b.margem           - a.margem);           break;
    case 'nome':        marcas.sort((a, b) => a.desc_marca.localeCompare(b.desc_marca));break;
    default: break;
  }

  const totalGeral = marcas.reduce((acc, m) => ({
    total_venda:      acc.total_venda      + m.total_venda,
    lucro_total:      acc.lucro_total      + m.lucro_total,
    total_quantidade: acc.total_quantidade + m.total_quantidade,
    total_custo:      acc.total_custo      + m.total_custo,
  }), { total_venda: 0, lucro_total: 0, total_quantidade: 0, total_custo: 0 });

  const margemGeral = totalGeral.total_venda > 0
    ? ((totalGeral.lucro_total / totalGeral.total_venda) * 100).toFixed(1) : 0;

  const maxVenda = Math.max(...marcas.map(m => m.total_venda), 1);

  const toggleMarca = (chave) =>
    setExpandida(prev => prev === chave ? null : chave);

  const abrirPedidos = (prod) => {
    // passa loja para filtrar corretamente (pode ser 'all')
    setProdutoSelecionado({
      ...prod,
      id_loja: selectedLojaMarca === 'all' ? null : selectedLojaMarca,
    });
  };

  return (
    <>
      {/* Overlay do MarcasModal */}
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1050 }}
      />

      {/* Modal de marcas */}
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '96vw', maxWidth: 1100, maxHeight: '90vh',
        background: '#fff', borderRadius: 16, zIndex: 1051,
        display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden',
      }}>

        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
          padding: '18px 24px', display: 'flex',
          alignItems: 'center', justifyContent: 'space-between', flexShrink: 0,
        }}>
          <div>
            <h5 style={{ color: '#fff', margin: 0, fontWeight: 700 }}>🏷️ Dashboard por Marca</h5>
            <small style={{ color: 'rgba(255,255,255,0.75)' }}>
              {marcas.length} marcas · clique na marca para expandir · clique no produto para ver os pedidos
            </small>
          </div>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.2)', border: 'none',
            borderRadius: 8, color: '#fff', fontWeight: 700,
            fontSize: 18, width: 36, height: 36, cursor: 'pointer', lineHeight: 1,
          }}>×</button>
        </div>

        {/* Filtros */}
        <div style={{
          padding: '12px 24px', borderBottom: '1px solid #e9ecef',
          display: 'flex', gap: 12, flexWrap: 'wrap',
          alignItems: 'center', flexShrink: 0, background: '#f8f9fa',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#495057', whiteSpace: 'nowrap' }}>Loja:</label>
            <select
              className="form-select form-select-sm"
              style={{ width: 'auto', minWidth: 140 }}
              value={selectedLojaMarca}
              onChange={e => { setSelectedLojaMarca(e.target.value); setExpandida(null); }}
            >
              <option value="all">Todas as Lojas</option>
              {lojas.map(l => <option key={l} value={l}>{l}</option>)}
            </select>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#495057', whiteSpace: 'nowrap' }}>Ordenar por:</label>
            <select
              className="form-select form-select-sm"
              style={{ width: 'auto', minWidth: 160 }}
              value={sortMarca}
              onChange={e => setSortMarca(e.target.value)}
            >
              <option value="faturamento">💰 Faturamento</option>
              <option value="lucro">💵 Lucro</option>
              <option value="quantidade">📦 Quantidade</option>
              <option value="margem">📊 Margem %</option>
              <option value="nome">🔤 Nome (A-Z)</option>
            </select>
          </div>
        </div>

        {/* Cards totais */}
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 12, padding: '12px 24px',
          borderBottom: '1px solid #e9ecef', flexShrink: 0,
        }}>
          {[
            { label: 'Faturamento', value: formatCurrency(totalGeral.total_venda),  bg: '#198754', icon: '💰' },
            { label: 'Lucro Total',  value: formatCurrency(totalGeral.lucro_total),  bg: '#0d6efd', icon: '💵' },
            { label: 'Qtd Vendida',  value: totalGeral.total_quantidade,              bg: '#6c757d', icon: '📦' },
            { label: 'Margem Geral', value: `${margemGeral}%`,                        bg: '#fd7e14', icon: '📊' },
          ].map((card, i) => (
            <div key={i} style={{ background: card.bg, borderRadius: 10, padding: '10px 14px', color: '#fff' }}>
              <div style={{ fontSize: 11, opacity: 0.8, fontWeight: 600 }}>{card.icon} {card.label}</div>
              <div style={{ fontSize: 18, fontWeight: 700, marginTop: 4 }}>{card.value}</div>
            </div>
          ))}
        </div>

        {/* Lista com accordion */}
        <div style={{ overflowY: 'auto', flex: 1, padding: '16px 24px' }}>
          {marcas.map((marca, idx) => {
            const barraPercent = ((marca.total_venda / maxVenda) * 100).toFixed(1);
            const margemColor  = marca.margem >= 30 ? '#198754' : marca.margem >= 10 ? '#fd7e14' : '#dc3545';
            const aberta       = expandida === marca.desc_marca;

            return (
              <div key={marca.desc_marca} style={{
                borderRadius: 10, marginBottom: 8, overflow: 'hidden',
                border: `1px solid ${aberta ? '#0d6efd' : '#e9ecef'}`,
                transition: 'border-color 0.2s',
              }}>
                {/* Cabeçalho clicável da marca */}
                <div
                  onClick={() => toggleMarca(marca.desc_marca)}
                  style={{
                    background: aberta ? '#eef3ff' : idx % 2 === 0 ? '#f8f9fa' : '#fff',
                    padding: '12px 16px', cursor: 'pointer', userSelect: 'none',
                    transition: 'background 0.2s',
                  }}
                >
                  <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 8,
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 200 }}>
                      <span style={{
                        background: aberta ? '#0d6efd' : '#6c757d',
                        color: '#fff', borderRadius: 6, width: 28, height: 28,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 12, fontWeight: 700, flexShrink: 0,
                        transition: 'background 0.2s',
                      }}>{idx + 1}</span>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 14, color: aberta ? '#0d6efd' : '#212529' }}>
                          {marca.desc_marca}
                        </div>
                        <div style={{ fontSize: 11, color: '#6c757d' }}>
                          {marca.skus} SKU{marca.skus !== 1 ? 's' : ''} · {marca.total_quantidade} unid.
                          <span style={{ marginLeft: 8, color: aberta ? '#0d6efd' : '#adb5bd', fontWeight: 600 }}>
                            {aberta ? '▲ recolher' : '▼ ver produtos'}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
                      {[
                        { label: 'Faturamento', value: formatCurrency(marca.total_venda),  color: '#198754' },
                        { label: 'Custo',        value: formatCurrency(marca.total_custo),  color: '#dc3545' },
                        { label: 'Lucro',        value: formatCurrency(marca.lucro_total),  color: '#0d6efd' },
                        { label: 'Margem',       value: `${marca.margem.toFixed(1)}%`,      color: margemColor },
                      ].map(v => (
                        <div key={v.label} style={{ textAlign: 'right' }}>
                          <div style={{ fontSize: 11, color: '#6c757d' }}>{v.label}</div>
                          <div style={{ fontWeight: 700, color: v.color, fontSize: 14 }}>{v.value}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{ height: 5, background: '#e9ecef', borderRadius: 4, overflow: 'hidden' }}>
                    <div style={{
                      height: '100%', width: `${barraPercent}%`,
                      background: aberta
                        ? 'linear-gradient(90deg, #0a58ca, #6ea8fe)'
                        : 'linear-gradient(90deg, #0d6efd, #6ea8fe)',
                      borderRadius: 4, transition: 'width 0.4s ease',
                    }} />
                  </div>
                </div>

                {/* Tabela de produtos (accordion) */}
                {aberta && (
                  <div style={{ borderTop: '2px solid #0d6efd', background: '#fff' }}>
                    <div style={{ overflowX: 'auto' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                        <thead>
                          <tr style={{ background: '#eef3ff' }}>
                            {[
                              { label: 'SKU',         align: 'left'  },
                              { label: 'Produto',     align: 'left'  },
                              { label: 'Loja',        align: 'left'  },
                              { label: 'Qtd',         align: 'right' },
                              { label: 'Preço Custo', align: 'right' },
                              { label: 'Faturamento', align: 'right' },
                              { label: 'Custo Total', align: 'right' },
                              { label: 'Lucro',       align: 'right' },
                              { label: 'Margem',      align: 'right' },
                              { label: 'Pedidos',     align: 'center'},
                            ].map(h => (
                              <th key={h.label} style={{
                                padding: '8px 10px', fontWeight: 600,
                                color: '#0d6efd', textAlign: h.align,
                                borderBottom: '1px solid #dee2e6', whiteSpace: 'nowrap',
                              }}>{h.label}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {marca.produtos.map((prod, pidx) => {
                            const margem = prod.total_venda > 0
                              ? ((prod.lucro_total / prod.total_venda) * 100).toFixed(1) : 0;
                            const mColor = parseFloat(margem) >= 30 ? '#198754'
                              : parseFloat(margem) >= 10 ? '#fd7e14' : '#dc3545';
                            const qtdPedidos = pedidos.filter(p =>
                              p.sku === prod.sku &&
                              (selectedLojaMarca === 'all' ? true : p.id_loja === selectedLojaMarca)
                            ).length;
                            return (
                              <tr key={pidx} style={{ background: pidx % 2 === 0 ? '#f8f9fa' : '#fff' }}>
                                <td style={{ padding: '6px 10px', color: '#6c757d', whiteSpace: 'nowrap' }}>
                                  {prod.sku || 'N/A'}
                                </td>
                                <td style={{ padding: '6px 10px', maxWidth: 260 }}>
                                  {prod.descricao.length > 48
                                    ? prod.descricao.substring(0, 48) + '…'
                                    : prod.descricao}
                                </td>
                                <td style={{ padding: '6px 10px', whiteSpace: 'nowrap', color: '#495057' }}>
                                  {prod.id_loja}
                                </td>
                                <td style={{ padding: '6px 10px', textAlign: 'right', fontWeight: 600 }}>
                                  {prod.total_quantidade}
                                </td>
                                <td style={{ padding: '6px 10px', textAlign: 'right' }}>
                                  {formatCurrency(prod.precocusto)}
                                </td>
                                <td style={{ padding: '6px 10px', textAlign: 'right', color: '#198754', fontWeight: 700 }}>
                                  {formatCurrency(prod.total_venda)}
                                </td>
                                <td style={{ padding: '6px 10px', textAlign: 'right', color: '#dc3545' }}>
                                  {formatCurrency(prod.total_custo)}
                                </td>
                                <td style={{ padding: '6px 10px', textAlign: 'right', color: '#0d6efd', fontWeight: 700 }}>
                                  {formatCurrency(prod.lucro_total)}
                                </td>
                                <td style={{ padding: '6px 10px', textAlign: 'right', fontWeight: 700, color: mColor }}>
                                  {margem}%
                                </td>
                                {/* ── BOTÃO VER PEDIDOS ── */}
                                <td style={{ padding: '6px 10px', textAlign: 'center' }}>
                                  <button
                                    onClick={e => { e.stopPropagation(); abrirPedidos(prod); }}
                                    title="Ver pedidos deste produto"
                                    style={{
                                      background: '#198754', color: '#fff',
                                      border: 'none', borderRadius: 6,
                                      padding: '3px 10px', fontSize: 11,
                                      cursor: 'pointer', fontWeight: 600,
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    🧾 {qtdPedidos}
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr style={{ background: '#dce8ff', fontWeight: 700 }}>
                            <td colSpan={3} style={{ padding: '8px 10px', color: '#0d6efd', fontSize: 12 }}>
                              Subtotal — {marca.desc_marca}
                            </td>
                            <td style={{ padding: '8px 10px', textAlign: 'right', color: '#212529' }}>
                              {marca.total_quantidade}
                            </td>
                            <td />
                            <td style={{ padding: '8px 10px', textAlign: 'right', color: '#198754' }}>
                              {formatCurrency(marca.total_venda)}
                            </td>
                            <td style={{ padding: '8px 10px', textAlign: 'right', color: '#dc3545' }}>
                              {formatCurrency(marca.total_custo)}
                            </td>
                            <td style={{ padding: '8px 10px', textAlign: 'right', color: '#0d6efd' }}>
                              {formatCurrency(marca.lucro_total)}
                            </td>
                            <td style={{ padding: '8px 10px', textAlign: 'right', color: margemColor }}>
                              {marca.margem.toFixed(1)}%
                            </td>
                            <td />
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Modal de pedidos (sobre o modal de marcas) */}
      <PedidosModal
        show={!!produtoSelecionado}
        onClose={() => setProdutoSelecionado(null)}
        produto={produtoSelecionado}
        pedidos={pedidos}
        formatCurrency={formatCurrency}
      />
    </>
  );
};

// ─────────────────────────────────────────────
// COMPONENTE PRINCIPAL
// ─────────────────────────────────────────────
const SalesDashboard = () => {
  const [data, setData]               = useState([]);
  const [pedidos, setPedidos]         = useState([]);   // ← detalhe por pedido
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState(null);
  const [selectedLoja, setSelectedLoja] = useState('all');
  const [sortBy, setSortBy]           = useState('faturamento');
  const hoje = new Date().toISOString().split('T')[0];

  const [dataInicio, setDataInicio]   = useState(hoje);
  const [dataFim, setDataFim]         = useState(hoje);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const [showMarcasModal, setShowMarcasModal]     = useState(false);
  const [produtoPedidos, setProdutoPedidos]       = useState(null); // SKU clicado na lista geral

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const data1 = dataInicio.split('-').reverse().join('/');
      const data2 = dataFim.split('-').reverse().join('/');
      const response = await apinode.get(
        `/relprodutos/relatorio/vendas/${localStorage.idconta}?data1=${data1}&data2=${data2}`
      );
      if (!response.data) throw new Error('Erro ao buscar dados');
      setData(response.data.data    || []);
      setPedidos(response.data.pedidos || []);
      setCurrentPage(1);
    } catch (err) {
      setError('Erro ao carregar dados da API.');
      setData([]);
      setPedidos([]);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

  const getLojaStats = () => {
    const stats = {};
    data.forEach((item) => {
      if (!stats[item.id_loja]) {
        stats[item.id_loja] = { total_venda: 0, total_custo: 0, lucro_total: 0, quantidade: 0, produtos: 0 };
      }
      stats[item.id_loja].total_venda  += item.total_venda;
      stats[item.id_loja].total_custo  += item.total_custo;
      stats[item.id_loja].lucro_total  += item.lucro_total;
      stats[item.id_loja].quantidade   += item.total_quantidade;
      stats[item.id_loja].produtos     += 1;
    });
    return stats;
  };

  const getFilteredProducts = () => {
    let filtered = selectedLoja === 'all' ? data : data.filter(i => i.id_loja === selectedLoja);
    switch (sortBy) {
      case 'faturamento': return filtered.sort((a, b) => b.total_venda - a.total_venda);
      case 'quantidade':  return filtered.sort((a, b) => b.total_quantidade - a.total_quantidade);
      case 'lucro':       return filtered.sort((a, b) => b.lucro_total - a.lucro_total);
      case 'margem':      return filtered.sort((a, b) => {
        const mA = a.total_venda > 0 ? (a.lucro_total / a.total_venda) * 100 : 0;
        const mB = b.total_venda > 0 ? (b.lucro_total / b.total_venda) * 100 : 0;
        return mB - mA;
      });
      case 'produto': return filtered.sort((a, b) => a.descricao.localeCompare(b.descricao));
      case 'sku':     return filtered.sort((a, b) => (a.sku || '').localeCompare(b.sku || ''));
      default:        return filtered.sort((a, b) => b.total_venda - a.total_venda);
    }
  };

  const getTotalStats = () => {
    const filtered = selectedLoja === 'all' ? data : data.filter(i => i.id_loja === selectedLoja);
    return filtered.reduce(
      (acc, item) => ({
        total_venda: acc.total_venda + item.total_venda,
        total_custo: acc.total_custo + item.total_custo,
        lucro_total: acc.lucro_total + item.lucro_total,
        quantidade:  acc.quantidade  + item.total_quantidade,
      }),
      { total_venda: 0, total_custo: 0, lucro_total: 0, quantidade: 0 }
    );
  };

  const exportarExcel = () => {
    try {
      const filteredProducts = getFilteredProducts();
      const totalStats = getTotalStats();
      const margemLucro = totalStats.total_venda > 0
        ? ((totalStats.lucro_total / totalStats.total_venda) * 100).toFixed(1) : 0;
      const excelData = filteredProducts.map((prod, idx) => {
        const margem = prod.total_venda > 0
          ? ((prod.lucro_total / prod.total_venda) * 100).toFixed(1) : 0;
        return {
          '#': idx + 1, 'SKU': prod.sku || 'N/A', 'Produto': prod.descricao,
          'Loja': `Loja ${prod.id_loja}`, 'Quantidade': prod.total_quantidade,
          'Preço Custo': prod.precocusto, 'Faturamento': prod.total_venda,
          'Custo Total': prod.total_custo, 'Lucro': prod.lucro_total, 'Margem %': `${margem}%`,
        };
      });
      excelData.push({
        '#': '', 'SKU': '', 'Produto': 'TOTAL', 'Loja': '',
        'Quantidade': totalStats.quantidade, 'Preço Custo': '',
        'Faturamento': totalStats.total_venda, 'Custo Total': totalStats.total_custo,
        'Lucro': totalStats.lucro_total, 'Margem %': `${margemLucro}%`,
      });
      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Vendas');
      XLSX.writeFile(wb, `relatorio_vendas_${dataInicio}_a_${dataFim}.xlsx`);
    } catch (err) {
      setError('Erro ao exportar Excel: ' + err.message);
    }
  };

  const gerarPDF = () => {
    try {
      const filteredProducts = getFilteredProducts();
      const totalStats = getTotalStats();
      const margemLucro = totalStats.total_venda > 0
        ? ((totalStats.lucro_total / totalStats.total_venda) * 100).toFixed(1) : 0;
      const tableBody = [[
        { text: '#',           bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'SKU',         bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'Produto',     bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'Loja',        bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'Qtd',         bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'Preço Custo', bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'Faturamento', bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'Custo Total', bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'Lucro',       bold: true, color: '#fff', fillColor: '#0d6efd' },
        { text: 'Margem %',    bold: true, color: '#fff', fillColor: '#0d6efd' },
      ]];
      filteredProducts.forEach((prod, idx) => {
        const margem  = prod.total_venda > 0
          ? ((prod.lucro_total / prod.total_venda) * 100).toFixed(1) : 0;
        const bgColor = idx % 2 === 0 ? '#f8f9fa' : '#fff';
        tableBody.push([
          { text: String(idx + 1),                 fillColor: bgColor },
          { text: prod.sku || 'N/A',               fillColor: bgColor, fontSize: 8 },
          { text: prod.descricao.substring(0, 35), fillColor: bgColor },
          { text: `Loja ${prod.id_loja}`,          alignment: 'center', fillColor: bgColor },
          { text: String(prod.total_quantidade),   alignment: 'center', fillColor: bgColor },
          { text: formatCurrency(prod.precocusto), alignment: 'right',  fillColor: bgColor },
          { text: formatCurrency(prod.total_venda),alignment: 'right',  color: '#198754', bold: true, fillColor: bgColor },
          { text: formatCurrency(prod.total_custo),alignment: 'right',  fillColor: bgColor },
          { text: formatCurrency(prod.lucro_total),alignment: 'right',  color: '#0d6efd', bold: true, fillColor: bgColor },
          { text: `${margem}%`,                    alignment: 'right',  fillColor: bgColor },
        ]);
      });
      pdfMake.createPdf({
        pageOrientation: 'landscape', pageSize: 'A4', pageMargins: [40, 50, 40, 60],
        header: { text: 'RELATÓRIO DE VENDAS', fontSize: 18, bold: true, color: '#0d6efd', alignment: 'center', margin: [40, 20, 40, 5] },
        footer: (cp, pc) => ({ text: `Página ${cp} de ${pc}`, alignment: 'center', fontSize: 9, color: '#666', margin: [40, 20, 40, 20] }),
        content: [
          { text: `Período: ${dataInicio} a ${dataFim}`, fontSize: 11, color: '#666', alignment: 'center', marginBottom: 20 },
          {
            columns: [
              { stack: [{ text: 'FATURAMENTO', fontSize: 9, color: '#fff', bold: true }, { text: formatCurrency(totalStats.total_venda), fontSize: 14, bold: true, color: '#fff', marginTop: 5 }], fillColor: '#198754', padding: [12,15,12,15], margin: [0,0,10,0] },
              { stack: [{ text: 'CUSTO TOTAL',  fontSize: 9, color: '#fff', bold: true }, { text: formatCurrency(totalStats.total_custo), fontSize: 14, bold: true, color: '#fff', marginTop: 5 }], fillColor: '#dc3545', padding: [12,15,12,15], margin: [0,0,10,0] },
              { stack: [{ text: 'LUCRO',         fontSize: 9, color: '#fff', bold: true }, { text: formatCurrency(totalStats.lucro_total), fontSize: 14, bold: true, color: '#fff', marginTop: 5 }], fillColor: '#0d6efd', padding: [12,15,12,15], margin: [0,0,10,0] },
              { stack: [{ text: 'MARGEM',        fontSize: 9, color: '#000', bold: true }, { text: `${margemLucro}%`,                      fontSize: 14, bold: true, color: '#000', marginTop: 5 }], fillColor: '#ffc107', padding: [12,15,12,15] },
            ],
            marginBottom: 25,
          },
          { text: `LISTA DE PRODUTOS (${filteredProducts.length})`, fontSize: 12, bold: true, color: '#333', marginBottom: 10 },
          {
            table: { headerRows: 1, widths: ['4%','8%','24%','7%','6%','10%','11%','10%','11%','9%'], body: tableBody },
            layout: {
              hLineWidth: (i, node) => i === 0 || i === node.table.body.length ? 2 : 0.5,
              vLineWidth: () => 0.5, hLineColor: '#dee2e6', vLineColor: '#dee2e6',
              paddingLeft: () => 8, paddingRight: () => 8, paddingTop: () => 6, paddingBottom: () => 6,
            },
            fontSize: 9,
          },
          { marginTop: 25, columns: [
            { text: `Gerado em: ${new Date().toLocaleString('pt-BR')}`, fontSize: 8, color: '#999' },
            { text: `Loja: ${selectedLoja === 'all' ? 'Todas' : `Loja ${selectedLoja}`}`, fontSize: 8, color: '#999', alignment: 'right' },
          ]},
        ],
      }).open();
    } catch (err) {
      setError('Erro ao gerar PDF: ' + err.message);
    }
  };

  const lojaStats         = getLojaStats();
  const filteredProducts  = getFilteredProducts();
  const totalStats        = getTotalStats();
  const margemLucro       = totalStats.total_venda > 0
    ? ((totalStats.lucro_total / totalStats.total_venda) * 100).toFixed(1) : 0;
  const totalPages        = Math.ceil(filteredProducts.length / itemsPerPage);
  const startIdx          = (currentPage - 1) * itemsPerPage;
  const paginatedProducts = filteredProducts.slice(startIdx, startIdx + itemsPerPage);

  return (
    <>
      <Navbar />

      {/* Modal de marcas (passa pedidos para drilldown interno) */}
      <MarcasModal
        show={showMarcasModal}
        onClose={() => setShowMarcasModal(false)}
        data={data}
        pedidos={pedidos}
        formatCurrency={formatCurrency}
      />

      {/* Modal de pedidos direto da lista geral */}
      <PedidosModal
        show={!!produtoPedidos}
        onClose={() => setProdutoPedidos(null)}
        produto={produtoPedidos}
        pedidos={pedidos}
        formatCurrency={formatCurrency}
      />

      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" />

      <div className="min-vh-100 bg-light">
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top shadow-sm">
          <div className="container-lg">
            <span className="navbar-brand mb-0 h1 fw-bold text-primary">📊 Vendas Pro</span>
            {data.length > 0 && (
              <>
                <button onClick={() => setShowMarcasModal(true)} className="btn btn-outline-primary fw-semibold me-2">
                  🏷️ Por Marca
                </button>
                <button onClick={gerarPDF}      className="btn btn-warning fw-semibold me-2">📥 Gerar PDF</button>
                <button onClick={exportarExcel} className="btn btn-success fw-semibold">📊 Exportar Excel</button>
              </>
            )}
          </div>
        </nav>

        <div className="container-lg py-4">
          {/* Filtros */}
          <div className="card shadow-sm mb-4 border-0">
            <div className="card-body">
              <h6 className="card-title fw-bold mb-3">Filtros de Busca</h6>
              <div className="row g-3">
                <div className="col-lg-3">
                  <label className="form-label fw-semibold">Data Início</label>
                  <input type="date" className="form-control" value={dataInicio} onChange={e => setDataInicio(e.target.value)} />
                </div>
                <div className="col-lg-3">
                  <label className="form-label fw-semibold">Data Fim</label>
                  <input type="date" className="form-control" value={dataFim} onChange={e => setDataFim(e.target.value)} />
                </div>
                <div className="col-lg-3">
                  <label className="form-label fw-semibold">Loja</label>
                  <select className="form-select" value={selectedLoja} onChange={e => setSelectedLoja(e.target.value)}>
                    <option value="all">Todas as Lojas</option>
                    {Object.keys(lojaStats).map(loja => (
                      <option key={loja} value={loja}>Loja {loja}</option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-2">
                  <label className="form-label fw-semibold">Ordenar por</label>
                  <select className="form-select" value={sortBy} onChange={e => setSortBy(e.target.value)}>
                    <option value="faturamento">💰 Faturamento</option>
                    <option value="quantidade">📦 Quantidade</option>
                    <option value="lucro">💵 Lucro</option>
                    <option value="margem">📊 Margem %</option>
                    <option value="produto">🔤 Produto (A-Z)</option>
                    <option value="sku">🏷️ SKU</option>
                  </select>
                </div>
                <div className="col-lg-1">
                  <label className="form-label fw-semibold">&nbsp;</label>
                  <button onClick={fetchData} className="btn btn-primary w-100 fw-semibold" disabled={loading}>
                    {loading ? '⏳' : '🔍'}
                  </button>
                </div>
              </div>
              {error && <div className="alert alert-danger mt-3 mb-0">{error}</div>}
            </div>
          </div>

          {data.length > 0 && (
            <>
              {/* ── CARDS DE TOTAIS — agora com 5 cards incluindo Custo Total ── */}
              <div className="row g-3 mb-4">
                <div className="col-lg">
                  <div className="card bg-success text-white shadow-sm border-0 h-100">
                    <div className="card-body">
                      <small className="fw-semibold opacity-75">💰 Faturamento</small>
                      <h4 className="mt-2 mb-0">{formatCurrency(totalStats.total_venda)}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg">
                  <div className="card bg-danger text-white shadow-sm border-0 h-100">
                    <div className="card-body">
                      <small className="fw-semibold opacity-75">🏷️ Custo Total</small>
                      <h4 className="mt-2 mb-0">{formatCurrency(totalStats.total_custo)}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg">
                  <div className="card bg-primary text-white shadow-sm border-0 h-100">
                    <div className="card-body">
                      <small className="fw-semibold opacity-75">💵 Lucro Total</small>
                      <h4 className="mt-2 mb-0">{formatCurrency(totalStats.lucro_total)}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg">
                  <div className="card bg-info text-white shadow-sm border-0 h-100">
                    <div className="card-body">
                      <small className="fw-semibold opacity-75">📦 Qtd Vendida</small>
                      <h4 className="mt-2 mb-0">{totalStats.quantidade}</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg">
                  <div className="card bg-warning text-dark shadow-sm border-0 h-100">
                    <div className="card-body">
                      <small className="fw-semibold opacity-75">📊 Margem Lucro</small>
                      <h4 className="mt-2 mb-0">{margemLucro}%</h4>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tabela */}
              <div className="card shadow-sm border-0">
                <div className="card-header bg-primary text-white fw-bold">
                  📦 Lista de Produtos ({filteredProducts.length})
                </div>
                <div className="table-responsive">
                  <table className="table table-hover table-striped mb-0 table-sm">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: '4%',  minWidth: 40  }}>#</th>
                        <th style={{ width: '8%',  minWidth: 80  }}>SKU</th>
                        <th style={{ minWidth: 260 }}>Produto</th>
                        <th style={{ width: '7%',  minWidth: 60  }} className="text-center">Loja</th>
                        <th style={{ width: '5%',  minWidth: 45  }} className="text-center">Qtd</th>
                        <th style={{ width: '9%',  minWidth: 90  }} className="text-end">Preço Custo</th>
                        <th style={{ width: '10%', minWidth: 100 }} className="text-end">Faturamento</th>
                        <th style={{ width: '9%',  minWidth: 90  }} className="text-end">Custo Total</th>
                        <th style={{ width: '10%', minWidth: 90  }} className="text-end">Lucro</th>
                        <th style={{ width: '8%',  minWidth: 70  }} className="text-end">Margem %</th>
                        <th style={{ width: '6%',  minWidth: 70  }} className="text-center">Pedidos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedProducts.map((prod, idx) => {
                        const margem = prod.total_venda > 0
                          ? ((prod.lucro_total / prod.total_venda) * 100).toFixed(1) : 0;
                        const qtdPedidos = pedidos.filter(p =>
                          p.sku === prod.sku &&
                          (selectedLoja === 'all' ? true : p.id_loja === selectedLoja)
                        ).length;
                        return (
                          <tr key={startIdx + idx}>
                            <td style={{ fontSize: '0.9rem' }}>{startIdx + idx + 1}</td>
                            <td style={{ fontSize: '0.85rem' }} className="text-muted">{prod.sku || 'N/A'}</td>
                            <td className="fw-semibold" style={{ fontSize: '0.9rem' }}>{prod.descricao.substring(0, 44)}</td>
                            <td className="text-center" style={{ fontSize: '0.9rem' }}>{prod.id_loja}</td>
                            <td className="text-center" style={{ fontSize: '0.9rem' }}>{prod.total_quantidade}</td>
                            <td className="text-end"   style={{ fontSize: '0.9rem' }}>{formatCurrency(prod.precocusto)}</td>
                            <td className="text-end text-success fw-semibold" style={{ fontSize: '0.9rem' }}>{formatCurrency(prod.total_venda)}</td>
                            <td className="text-end text-danger"              style={{ fontSize: '0.9rem' }}>{formatCurrency(prod.total_custo)}</td>
                            <td className="text-end text-primary fw-semibold" style={{ fontSize: '0.9rem' }}>{formatCurrency(prod.lucro_total)}</td>
                            <td className="text-end"   style={{ fontSize: '0.9rem' }}>{margem}%</td>
                            {/* ── BOTÃO VER PEDIDOS na lista geral ── */}
                            <td className="text-center" style={{ fontSize: '0.9rem' }}>
                              <button
                                onClick={() => setProdutoPedidos({
                                  ...prod,
                                  id_loja: selectedLoja === 'all' ? null : selectedLoja,
                                })}
                                title="Ver pedidos"
                                style={{
                                  background: '#198754', color: '#fff',
                                  border: 'none', borderRadius: 6,
                                  padding: '2px 9px', fontSize: 11,
                                  cursor: 'pointer', fontWeight: 600,
                                }}
                              >
                                🧾 {qtdPedidos}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {totalPages > 1 && (
                  <div className="card-footer bg-light d-flex justify-content-between align-items-center">
                    <small className="text-muted">
                      Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong>
                    </small>
                    <div className="btn-group">
                      <button type="button" className="btn btn-outline-secondary btn-sm"
                        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                        disabled={currentPage === 1}>◀ Anterior</button>
                      <button type="button" className="btn btn-outline-secondary btn-sm"
                        onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                        disabled={currentPage === totalPages}>Próximo ▶</button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          {data.length === 0 && !loading && (
            <div className="card border-0 shadow-sm text-center py-5">
              <div className="card-body">
                <p className="text-muted fs-5">🔍 Clique em "Buscar" para carregar os dados de vendas</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export { SalesDashboard };